import React, { Component } from 'react'
import Overview from '../Overview/Overview'
import Files from '../Files/Files'
import Notes from '../Notes/Notes'
import People from '../People/People'
import Projects from '../Projects/Projects'
import Tasks from '../Tasks/Tasks'
import Authorization from '../Authorization/Authorization'
import Goals from '../Goals/Goals'
import Needs from '../Needs/Needs'
import Forms from '../Forms/Forms'
import Documents from '../Documents/Documents'
import EmployeePreferences from '../EmployeePreferences/EmployeePreferences'
import Health from '../Health/Health'
import Medicare from '../Medicare/Medicare'
import Scheduler from '../../Scheduler/Scheduler'
import axios from 'axios';
import moment from "moment";
import { APIURL } from '../../../config'
import "./details.css"
import { Tabs, Tab } from '@mui/material'

class DetailsPane extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedTab: 0,
      selectedGroupTab: 0,
      project: {},
      contactsList: [],
      loading: true,
      edited: false,
      customerType: null,
      customerStatus: null,
      loc_list: null,
      primaryBusinessType: null,
    }
    this.selectTab = this.selectTab.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
    this.fetchData = this.fetchData.bind(this)
  }

  async fetchData() {
    // { "primaryBusinessType": "Support Coordination", "featureValue": 101 },
    // { "primaryBusinessType": "Service Provider", "featureValue": 102 },
    let pBusinessType = this.props.user?.comp_settings.find(setting => setting.feature_value === 'primaryBusinessType') ? this.props.user.comp_settings.filter((setting) => setting.feature_value === "primaryBusinessType")[0].feature_id : 101;

    this.setState({ loading: false, primaryBusinessType: pBusinessType })
  }

  async componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate(prevProps) {
    if (this.props.cust_details !== prevProps.cust_details) {
      this.setState({ loading: true, selectedTab: 0, selectedGroupTab: 0 })
      this.fetchData()
    }
  }

  selectTab(event, newValue) {
    this.setState({
      selectedTab: newValue, edited: true
    })
  }

  getGroups() {
    const pbt = this.state.primaryBusinessType;
    const subs = this.props.user?.subs || [];
    return [
      {
        label: 'OVERVIEW',
        value: 0,
        subTabs: null,
        directTab: 0,
      },
      {
        label: 'CLINICAL & CARE',
        value: 1,
        subTabs: [
          { label: 'GOALS', tabId: 7 },
          { label: 'NEEDS', tabId: 8 },
          { label: 'HEALTH', tabId: 12 },
          { label: 'MEDICARE', tabId: 13 },
          { label: 'NOTES', tabId: 5 },
        ],
      },
      {
        label: 'FORMS & FILES',
        value: 2,
        subTabs: [
          { label: 'FILES', tabId: 4 },
          ...(subs.find((d) => d.feature_id === 15) ? [{ label: 'FORMS', tabId: 10 }] : []),
          ...(pbt === 101 ? [{ label: 'MTS', tabId: 9 }] : []),
          ...(pbt === 102 || pbt === 105 ? [{ label: 'AUTHORIZATION', tabId: 6 }] : []),
        ],
      },
      {
        label: 'PROJECTS/TASKS',
        value: 3,
        subTabs: [
          { label: 'PROJECTS', tabId: 1 },
          { label: 'TASKS', tabId: 2 },
          { label: 'PEOPLE', tabId: 3 },
        ],
      },
      {
        label: 'PREFERENCES',
        value: 4,
        subTabs: null,
        directTab: 11,
      },
      {
        label: 'SCHEDULE',
        value: 5,
        subTabs: null,
        directTab: 14,
      },
    ];
  }

  selectGroupTab = (groupIndex) => {
    const groups = this.getGroups();
    const group = groups[groupIndex];
    let newSelectedTab = this.state.selectedTab;
    if (group.directTab !== undefined) {
      newSelectedTab = group.directTab;
    } else if (group.subTabs && group.subTabs.length > 0) {
      newSelectedTab = group.subTabs[0].tabId;
    }
    this.setState({ selectedGroupTab: groupIndex, selectedTab: newSelectedTab, edited: true });
  }

  isFormValidated = (objForVal) => {
    var missingField = {
      isValidated: true
    }
    let temp = Object.keys(objForVal)
    if (temp[0] === 'selectedEmp') {

      let selectedEm = objForVal.selectedEmp
      for (let i = 0; i < selectedEm.length; i++) {
        for (let objKey in selectedEm[i]) {
          if (
            selectedEm[i][objKey] === "" ||
            selectedEm[i][objKey] === undefined ||
            selectedEm[i][objKey].length === 0
          ) {
            missingField.isValidated = false;
            missingField.missingKey = objKey
            return missingField
          }
        }
      }
    }




    for (let objKey in objForVal) {
      if (
        objForVal[objKey] === "" ||
        objForVal[objKey] === undefined ||
        objForVal[objKey] === null ||
        objForVal[objKey].length === 0
      ) {
        if (
          objKey === "address2" ||
          objKey === "location_addr2" ||
          objKey === "tComment" ||
          objKey === "cus_local_id" ||
          //objKey === "ddd_id" ||
          objKey === "address_line_2" ||
          objKey === "email" ||
          objKey === "pManager" ||
          objKey === "medicaid_id" ||
          objKey === "medicaid_eligible" ||
          objKey === "sign_page_date" ||
          objKey === "last_plan_approval_date" ||
          objKey === "last_assess_date" ||
          objKey === "renewal_date" ||
          //objKey === "DDDID" ||
          objKey === "personal_days_off" ||
          objKey === "vacation_days" ||
          objKey === "DDD_tier" ||
          objKey === "diagnose_code" ||
          objKey === "func_criteria_met" ||
          objKey === "waiver_program" ||
          objKey === "NJCATSelfcare" ||
          objKey === "NJCATBehavioral" ||
          objKey === "NJCATMedical" ||
          objKey === "NJCATFCA" ||
          objKey === "MedicaidEndDate" ||
          objKey === "AgencyAssignDate" ||
          objKey === "County" ||
          objKey === "Race" ||
          objKey === "Ethnicity" ||
          objKey === "TransferOutReason" ||
          objKey === "TransferOutDate" ||
          objKey === "tContacts" ||
          objKey === "tTravelTime" ||
          objKey === "tExpenses" ||
          objKey === "pro_program_id" ||
          objKey === "place01char" ||
          objKey === "place02char" ||
          objKey === "place03char" ||
          objKey === "place04date" ||
          objKey === "place05date" ||
          objKey === "place06number" ||
          objKey === "place07number"
        ) {
          // return true
          continue;
        } else if (objForVal["cus_is_company"] === true && objForVal["company_name"] === "") {
          missingField.isValidated = false;
          missingField.missingKey = "company_name"
          return missingField;
        }
        else {
          console.log(objKey);

          // if (
          //   (objKey === "company_name" &&
          //     objForVal["first_name"] !== "" &&
          //     objForVal["last_name"] !== "") ||
          //   ((objKey === "first_name" || objKey === "last_name") &&
          //     objForVal["company_name"] !== "" && objForVal["company_name"] !== undefined)
          // ) {
          //   continue;
          // } else {
          missingField.isValidated = false;
          missingField.missingKey = objKey
          return missingField;
          // }
        }
      } else if (Array.isArray(objForVal[objKey])) {
        let arrValid = objForVal[objKey].every(function (objTesting) {
          for (let objTestKey in objTesting) {
            console.log(objTestKey);
            if (
              objTesting[objTestKey] === "" ||
              objTesting[objTestKey] === undefined
            ) {
              if (
                objTestKey === "address_line_2" ||
                objTestKey === "location_addr2"
              ) {
                // return true
                continue;
              } else {
                missingField.isValidated = false;
                missingField.missingKey = objKey
                return missingField;
              }
            }
          }
          return true;
        });
        if (!arrValid) return false;
      } else if (objKey === "active_plan_version") {
        for (const digit of objForVal[objKey]) {
          if (Number.isNaN(parseInt(digit)) && digit !== ".") {
            alert("PROJECT ACTIVE PLAN VERSION has to be a number");
            objForVal[objKey] = "";
            return false;
          }
        }
      }
      else if (objKey === "dob") {
        if (!moment(objForVal[objKey]).isValid()) {
          missingField.isValidated = false;
          missingField.missingKey = objKey
          return missingField;
        }
      } else if (objKey === "email") {
        if (objForVal[objKey].includes("@") === false || objForVal[objKey].includes(".") === false) {
          missingField.isValidated = false;
          missingField.missingKey = objKey
          return missingField;
        }
      }
    }

    return missingField;
  };

  isNewFormValidated = (objForVal) => {
    console.log('>>>>>>>>>>> ', objForVal)
    var missingField = {
      isValidated: true
    }
    let temp = Object.keys(objForVal)
    if (temp[0] === 'selectedEmp') {

      let selectedEm = objForVal.selectedEmp
      for (let i = 0; i < selectedEm.length; i++) {
        for (let objKey in selectedEm[i]) {
          if (
            selectedEm[i][objKey] === "" ||
            selectedEm[i][objKey] === undefined ||
            selectedEm[i][objKey].length === 0
          ) {
            missingField.isValidated = false;
            missingField.missingKey = objKey
            return missingField
          }
        }
      }
    }




    for (let objKey in objForVal) {
      if ((objKey !== "Cemail" && objKey !== "designation") &&
        (objForVal[objKey] === "" ||
          objForVal[objKey] === undefined ||
          objForVal[objKey].length === 0)
      ) {
        if (
          objKey === "address2" ||
          objKey === "location_addr2" ||
          objKey === "tComment" ||
          objKey === "cus_local_id" ||
          //objKey === "ddd_id" ||
          objKey === "address_line_2" ||
          // objKey === "email" ||
          objKey === "pSelfPay" ||
          objKey === "pPrimaryPayer" ||
          objKey === "pSecondaryPayer" ||
          objKey === "medicaid_id" ||
          objKey === "medicaid_eligible" ||
          objKey === "sign_page_date" ||
          objKey === "last_plan_approval_date" ||
          objKey === "last_assess_date" ||
          objKey === "renewal_date" ||
          //objKey === "DDDID" ||
          objKey === "personal_days_off" ||
          objKey === "vacation_days" ||
          objKey === "DDD_tier" ||
          objKey === "diagnose_code" ||
          objKey === "func_criteria_met" ||
          objKey === "waiver_program" ||
          objKey === "NJCATSelfcare" ||
          objKey === "NJCATBehavioral" ||
          objKey === "NJCATMedical" ||
          objKey === "NJCATFCA" ||
          objKey === "MedicaidEndDate" ||
          objKey === "AgencyAssignDate" ||
          objKey === "County" ||
          objKey === "Race" ||
          objKey === "Ethnicity" ||
          objKey === "TransferOutReason" ||
          objKey === "TransferOutDate" ||
          objKey === "tContacts" ||
          objKey === "tTravelTime" ||
          objKey === "tExpenses" ||
          objKey === "pro_program_id" ||
          objKey === "place01char" ||
          objKey === "place02char" ||
          objKey === "place03char" ||
          objKey === "place04date" ||
          objKey === "place05date" ||
          objKey === "place06number" ||
          objKey === "place07number"
        ) {
          // return true
          continue;
        } else if (objForVal["cus_is_company"] === true && objForVal["company_name"] === "") {
          missingField.isValidated = false;
          missingField.missingKey = "company_name"
          return missingField;
        }
        else {
          console.log(objKey);

          if (
            (objKey === "company_name" &&
              objForVal["first_name"] !== "" &&
              objForVal["last_name"] !== "") ||
            ((objKey === "first_name" || objKey === "last_name") &&
              objForVal["company_name"] !== "" && objForVal["company_name"] !== undefined) || objKey === "address_maps"
          ) {
            continue;
          } else {
            missingField.isValidated = false;
            missingField.missingKey = objKey
            return missingField;
          }
        }
      } else if (Array.isArray(objForVal[objKey])) {
        let arrValid = objForVal[objKey].every(function (objTesting) {
          for (let objTestKey in objTesting) {
            console.log(objTestKey);
            if (
              objTesting[objTestKey] === "" ||
              objTesting[objTestKey] === undefined
            ) {
              if (
                objTestKey === "address_line_2" ||
                objTestKey === "location_addr2"
              ) {
                // return true
                continue;
              } else {
                missingField.isValidated = false;
                missingField.missingKey = objKey
                return missingField;
              }
            }
          }
          return true;
        });
        if (!arrValid) return false;
      } else if (objKey === "active_plan_version") {
        for (const digit of objForVal[objKey]) {
          if (Number.isNaN(parseInt(digit)) && digit !== ".") {
            alert("PROJECT ACTIVE PLAN VERSION has to be a number");
            objForVal[objKey] = "";
            return false;
          }
        }
      }
    }

    return missingField;
  };

  renderDetails() {
    if (this.state.loading) {
      return (
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )
    }

    switch (this.state.selectedTab) {
      case 0:
        return <Overview {...this.props} isFormValidated={this.isFormValidated} />
      case 1:
        return <Projects {...this.props} isNewFormValidated={this.isNewFormValidated} />
      case 2:
        return <Tasks {...this.props} isFormValidated={this.isFormValidated} isNewFormValidated={this.isNewFormValidated} />
      case 3:
        return <People {...this.props} />
      case 4:
        return <Files {...this.props} />
      case 5:
        return <Notes {...this.props} />
      case 6:
        return <Authorization {...this.props} />
      case 7:
        return <Goals {...this.props} />
      case 8:
        return <Needs {...this.props} />
      case 9:
        return <Documents {...this.props} />
      case 10:
        return <Forms {...this.props} />
      case 11:
        return <EmployeePreferences {...this.props} />
      case 12:
        return <Health {...this.props} />
      case 13:
        return <Medicare {...this.props} />
      case 14:
        return (
          <Scheduler
            {...this.props}
            selectedView="customer"
            selectedCustomerId={this.props.cus_id}
          />
        )
      default:
        return <div />
    }
  }

  render() {
    const groups = this.getGroups();
    const activeGroup = groups[this.state.selectedGroupTab] || groups[0];
    const subTabs = activeGroup.subTabs;

    return (
      <div style={{ width: '100%', height: '100%', paddingLeft: '15px', display: 'flex', flexDirection: 'column' }}>
        <div style={{ position: 'sticky', top: 0, zIndex: 100 }}>
          {/* Primary group tabs */}
          <Tabs
            value={this.state.selectedGroupTab}
            onChange={(e, v) => this.selectGroupTab(v)}
            variant="fullWidth"
            sx={{ width: '100%', borderBottom: '1px solid #e0e0e0' }}
          >
            {groups.map((group) => (
              <Tab key={group.value} value={group.value} label={group.label} />
            ))}
          </Tabs>

          {/* Secondary sub-tabs */}
          {subTabs && subTabs.length > 0 && (
            <Tabs
              value={this.state.selectedTab}
              onChange={this.selectTab}
              variant="scrollable"
              scrollButtons="auto"
              indicatorColor="secondary"
              sx={{ borderBottom: '1px solid #e0e0e0', minHeight: 34 }}
            >
              {subTabs.map((st) => (
                <Tab
                  key={st.tabId}
                  label={st.label}
                  value={st.tabId}
                  sx={{ minHeight: 34, minWidth: 72, px: 1, fontSize: '0.72rem' }}
                />
              ))}
            </Tabs>
          )}
        </div>

        <div className='cus_details_body' style={{ flex: 1, minHeight: 0, height: 'auto' }}>
          <div style={{ marginRight: '-12px', height: '100%' }}>
            {this.renderDetails()}
          </div>
        </div>
      </div>
    )
  }
}

export default DetailsPane
